import { Box } from "@mui/material";
import { useTu } from "@src/appV2/i18n/useTu";
import { Button } from "@src/appV2/redesign/components/Button";
import { Text } from "@src/appV2/redesign/components/Text";
import { Title } from "@src/appV2/redesign/components/Title";
import { BerlinThemeProvider } from "@src/appV2/redesign/theme/ThemeProvider";
import { routes } from "@src/appV2/redesign/utils/routes";
import { type ReactElement } from "react";
import { useLocation } from "react-router-dom";

export function LegacyLoginLinkPage(): ReactElement {
  const { tu } = useTu("login");
  const location = useLocation();
  const email = new URLSearchParams(location.search).get("email");
  const loginSearch = email ? new URLSearchParams({ email }).toString() : "";
  const loginPath = loginSearch ? `${routes.login}?${loginSearch}` : routes.login;

  return (
    <BerlinThemeProvider fullHeight>
      <Box
        sx={(theme) => ({
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          padding: 5,
          backgroundColor: theme.palette.background.page,
        })}
      >
        <Box
          sx={(theme) => ({
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 5,
            width: "100%",
            maxWidth: "28rem",
            padding: 7,
            textAlign: "center",
            backgroundColor: theme.palette.background.standout,
            border: 1,
            borderColor: theme.palette.border?.base,
            borderRadius: theme.borderRadius?.large,
            boxShadow: theme.shadow?.card,
          })}
        >
          <Title component="h5" bold>
            {tu("This login link is no longer supported")}
          </Title>
          <Text variant="body1" sx={(theme) => ({ color: theme.palette.text.secondary })}>
            {tu("Initiate sign in again to get a fresh code or link.")}
          </Text>
          <Button fullWidth href={loginPath} size="large" variant="primary">
            {tu("Go to login")}
          </Button>
        </Box>
      </Box>
    </BerlinThemeProvider>
  );
}
